<div class="categories-wrapper w-full">
  <div class="close-wrapper flex justify-end">
    <app-icon (click)="closeButtonClickHandler()"
              class="cursor-pointer close-icon"
              svgIcon="cross"></app-icon>
  </div>

  <div class="w-full flex justify-center flex-col items-center">
    <div class="flex flex-col w-full items-center justify-center">
      <div class="w-[90%]">
        <div class="w-full flex">
          <div class="filter-heading flex justify-start font-semibold font-poppins">
            Groups
          </div>

        </div>
        <hr class="separator"/>
        <div class="group-status-checkbox-wrapper">
          <app-check-box-input [controlName]="'active'"
                               [parentFormGroup]="form"
                               label="Active"></app-check-box-input>
        </div>
        <div class="group-status-checkbox-wrapper">
          <app-check-box-input [controlName]="'active'"
                               [parentFormGroup]="form"
                               label="Inactive"></app-check-box-input>
        </div>
      </div>
      <div class="w-[90%]">
        <div class="w-full flex">
          <div class="filter-heading flex justify-start font-semibold font-poppins">
            Unsafe Zone
          </div>

        </div>
        <hr class="separator"/>
        <div class="group-status-checkbox-wrapper">
          <app-check-box-input [controlName]="'active'"
                               [parentFormGroup]="form"
                               label="Danger Zone"></app-check-box-input>
        </div>
      </div>
      <div class="w-[90%]">
        <div class="w-full flex">
          <div class="filter-heading flex justify-start font-semibold font-poppins">
            Gender
          </div>

        </div>
        <hr class="separator"/>
        <div class="group-status-checkbox-wrapper">
          <app-check-box-input [controlName]="'active'"
                               [parentFormGroup]="form"
                               label="Male"></app-check-box-input>
        </div>
        <div class="group-status-checkbox-wrapper">
          <app-check-box-input [controlName]="'active'"
                               [parentFormGroup]="form"
                               label="Female"></app-check-box-input>
        </div>
        <div class="group-status-checkbox-wrapper">
          <app-check-box-input [controlName]="'active'"
                               [parentFormGroup]="form"
                               label="Other"></app-check-box-input>
        </div>
      </div>
      <div class="w-[90%]">
        <div class="w-full flex">
          <div class="filter-heading flex justify-start font-semibold font-poppins">
            BMI
          </div>

        </div>
        <hr class="separator"/>
        <div class="group-status-checkbox-wrapper">
          <app-check-box-input [controlName]="'active'"
                               [parentFormGroup]="form"
                               label="Lorem Ipsum"></app-check-box-input>
        </div>
      </div>
    </div>
    <hr class="separator"/>
  </div>
  <div class="w-[95%] flex justify-end confirm-button-wrapper">
    <app-primary-button
      (handleClick)="closeButtonClickHandler()"
      [type]="'small'">
      Apply Filter
    </app-primary-button>
  </div>
</div>
